import styled from 'styled-components';

export const MobileListWrapper = styled.div`
  @media (min-width: 769px) {
    display: none;
  }
`;

export const MobileListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 15px;
  margin-bottom: 10px;
  border: 1px solid #dadce0;

  .title {
    font-size: 18px;
    color: #b6266b;
    margin: 0;
    margin-bottom: 25px;
    max-width: 150px;
    margin-right: 15px;
  }

  .item {
    font-size: 14px;
    max-width: 150px;
    word-break: break-word;
  }

  .bold-item {
    font-size: 16px;
    font-weight: 600;
    max-width: 150px;
  }

  .label-item {
    margin-top: 25px;
    font-size: 14px;
    word-break: break-word;
    font-weight: 600;
    color: #cccccc;
  }
`;
